import { Component, TemplateRef, computed, contentChild, input, model } from '@angular/core';

@Component({
  selector: 'app-primeng-dialog',
  template: `
    <p-dialog 
      [visible]="visible()" 
      (visibleChange)="onVisibleChange($event)"
      [modal]="modal()" 
      [style]="dialogStyle()"
      [contentStyle]="dialogContentStyle()"
      [closable]="closable()"
      [draggable]="draggable()"
      [resizable]="resizable()"
      [blockScroll]="blockScroll()"
      [dismissableMask]="dismissableMask()"
      [closeOnEscape]="closeOnEscape()"
      [ngClass]="customClass()"
      [styleClass]="customClass()"
      [appendTo]="'body'">

      <ng-template #dialogHdr pTemplate="header">
        <ng-container *ngIf="dialogHeader(); else defaultHeader">
          <ng-container *ngTemplateOutlet="dialogHeader()!"></ng-container>
        </ng-container>
        <ng-template #defaultHeader>
          <span class="p-dialog-title" *ngIf="header()">{{ header() }}</span>
        </ng-template>
      </ng-template>

      <ng-container *ngTemplateOutlet="dialogContent()!"></ng-container>

      <ng-template #dialogFtr pTemplate="footer">
        <ng-container *ngIf="showFooter() || dialogFooter()">
          <ng-container *ngTemplateOutlet="dialogFooter()!"></ng-container>
        </ng-container>
      </ng-template>

    </p-dialog>
  `,
  styles: [`
    :host ::ng-deep .p-dialog .p-dialog-content {
      overflow-y: auto;
    }
  `],
  standalone: false,
})
export class PrimengDialogComponent {
  header = input<string>('');
  visible = model<boolean>(false);
  modal = input<boolean>(true);
  width = input<string>('50vw');
  maxWidth = input<string>('95vw');
  maxHeight = input<string>('78vh');
  closable = input<boolean>(true);
  draggable = input<boolean>(false);
  resizable = input<boolean>(false);
  showFooter = input<boolean>(false);
  customClass = input<string>('');
  blockScroll = input<boolean>(true);
  dismissableMask = input<boolean>(true);
  closeOnEscape = input<boolean>(true);
  style = input<Record<string, any> | null>(null);
  contentStyle = input<Record<string, any> | null>(null);

  dialogHeader = contentChild<TemplateRef<any>>('dialogHeader');
  dialogContent = contentChild<TemplateRef<any>>('dialogContent');
  dialogFooter = contentChild<TemplateRef<any>>('dialogFooter');

  dialogStyle = computed<Record<string, any>>(() => ({
    width: this.width(),
    maxWidth: this.maxWidth(),
    ...(this.style() || {})
  }));

  dialogContentStyle = computed<Record<string, any>>(() => ({
    maxHeight: this.maxHeight(),
    overflowY: 'auto',
    ...(this.contentStyle() || {})
  }));

  onVisibleChange(val: boolean) {
    this.visible.set(val);
  }
}
